import React from 'react';
import { Link } from 'react-router-dom';

import AdminLayout from 'Pages/Admin/AdminLayout';

import { PrimaryButton, SecondaryButton } from 'Components/Button';
import { FormHandler, Input, Toggle, DatePicker, Select, IsTranslatableWrapper } from 'Components/Form';
import { Alert } from 'Components/Partials';

import AdminAgendaApi from 'Services/Api/Admin/Agenda';
import SpeakerApi from 'Services/Api/Admin/Speaker';
import AdminGroupsApi from 'Services/Api/Admin/Groups';
class AgendaStore extends React.Component {

    /**
     * @var success
     * @type {string}
     */
    success = 'Agenda item ' + (this.props.match?.params?.agenda ? 'updated' : 'created') + ' successfully';

    /**
     * @var state
     * @type {{agenda_id: string}}
     */
    state = {
        agenda_id: this.props.match?.params?.agenda ?? '',
        speakers: [],
    };

    /**
     * @method componentDidMount
     */
    async componentDidMount() {
        if (this.state.agenda_id) {
            await this.loadAgenda();
        } else {
            this.props.setInitialValues({
                'active': true,
                'start_date_time': new Date(),
                'end_date_time': new Date(),
                'supported_languages': Object.keys(window.base.languages),
                'title': null,
                'content': null,
                'presenters': null,
                'show_add_to_agenda_button': false,
                'show_add_to_agenda_button_start_date_time': null,
                'show_add_to_agenda_button_end_date_time': null,
                'show_add_to_calendar_button': false,
                'show_add_to_calendar_button_only_if_in_agenda': false,
                'join_link': null,
                'join_link_display_start_date_time': null,
                'join_link_display_end_date_time': null,
                'join_link_display_only_if_in_agenda': false,
                'spaces': null,
                'waiting_list': false,
                'add_to_agenda_emails': false,
                'waiting_list_emails': false,
                'speakers': null,
            });
        }

        const speakers = await SpeakerApi.get('');

        this.setState({
            speakers: speakers.data.data.map((s) => ({ value: s.id, label: s.full_name })),
        })
    }

    /**
     * @method loadAgenda
     * @param {int} page
     */
    loadAgenda = async (page = 1) => {
        const { agenda_id } = this.state;

        const response = await AdminAgendaApi.get(agenda_id);

        let agenda = response.data.data;

        this.props.setForm({
            'active': agenda.active,
            'start_date_time': agenda.start_date_time,
            'end_date_time': agenda.end_date_time,
            'supported_languages': agenda.supported_languages,
            'title': agenda.title,
            'content': agenda.content,
            'presenters': agenda.presenters,
            'show_add_to_agenda_button': agenda.show_add_to_agenda_button,
            'show_add_to_agenda_button_start_date_time': agenda.show_add_to_agenda_button_start_date_time,
            'show_add_to_agenda_button_end_date_time': agenda.show_add_to_agenda_button_end_date_time,
            'show_add_to_calendar_button': agenda.show_add_to_calendar_button,
            'show_add_to_calendar_button_only_if_in_agenda': agenda.show_add_to_calendar_button_only_if_in_agenda,
            'join_link': agenda.join_link,
            'join_link_display_start_date_time': agenda.join_link_display_start_date_time,
            'join_link_display_end_date_time': agenda.join_link_display_end_date_time,
            'join_link_display_only_if_in_agenda': agenda.join_link_display_only_if_in_agenda,
            'spaces': agenda.spaces,
            'waiting_list': agenda.waiting_list,
            'add_to_agenda_emails': agenda.add_to_agenda_emails,
            'waiting_list_emails': agenda.waiting_list_emails,
            'speakers': agenda.speakers?.map(speaker => speaker.id),
            'user_type': agenda.user_type,
        });
    }

    /**
     * @method handleSubmit
     * @param {object} form
     * @return {Promise<*>}
     */
    handleSubmit = (form) => {
        const { agenda_id } = this.state;

        if (!form.spaces) {
            form.waiting_list = false;
        }

        if (!form.show_add_to_agenda_button) {
            form.add_to_agenda_emails = false;
        }

        if (!form.waiting_list) {
            form.waiting_list_emails = false;
        }

        if (agenda_id) {
            return AdminAgendaApi.patch(agenda_id, form);
        } else {
            return AdminAgendaApi.post(null, form);
        }
    };

    timezones = [
        {value: 'Group 1', label: 'Group 1'},
        {value: 'Group 1b', label: 'Group 1b'},
        {value: 'Group 2', label: 'Group 2'},
        {value: 'Group 2b', label: 'Group 2b'},
        {value: 'Group 3', label: 'Group 3'},
        {value: 'Group 3b', label: 'Group 3b'},
        {value: 'Group 4', label: 'Group 4'},
        {value: 'Group 4b', label: 'Group 4b'},
        {value: 'Group 5', label: 'Group 5'},
        {value: 'Group 5b', label: 'Group 5b'},
        {value: 'Virtual', label: 'Virtual'},
        {value: 'SPEEDO EVENTS TEAM', label: 'SPEEDO EVENTS TEAM'},
        {value: 'Evening', label: 'Evening'},
    ];

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { agenda_id } = this.state;
        const { form, working, alert, handleInput, getFieldError, handleSubmit } = this.props;

        let languages = Object.entries(window.base.languages).map((value, key) => {
            return {
                label: value[1],
                value: value[0],
            };
        });

        return (
            <AdminLayout title={'Admin Agenda - ' + (agenda_id ? 'Update' : 'Create') + ' Agenda Item'}>
                <form
                    className="divide-y divide-gray-200"
                    onSubmit={(e) => handleSubmit(e, this.handleSubmit, this.success, (agenda_id ? false : true))}
                >
                    <div className="mx-6">
                        {alert !== null && (<Alert {...alert} />)}

                        <div className="bg-gray-300 p-4 rounded mb-8">
                            <h3 className="text-lg leading-6 font-medium py-4 font-bold">Agenda Info</h3>

                            <div className="grid grid-cols-1 gap-4 py-8 border-0">
                                <div className="my-auto">
                                    <Toggle
                                        label="Active"
                                        value={form.active}
                                        error={getFieldError('active')}
                                        onChange={v => handleInput('active', v)}
                                    />
                                </div>

                                {languages.length > 1 &&
                                    <div>
                                        <Select
                                            label="Supported Languages"
                                            value={form.supported_languages}
                                            error={getFieldError('supported_languages')}
                                            onChange={(v) => handleInput('supported_languages', v)}
                                            options={languages}
                                            isMulti
                                        />
                                    </div>
                                }

                                <div>
                                    <IsTranslatableWrapper
                                        label="Title"
                                        value={form.title}
                                        id="title"
                                        error={getFieldError('title')}
                                        onChange={(v) => handleInput('title', v)}
                                        supported_languages={form.supported_languages}
                                        childComponent="Input"
                                        childProps={{}}
                                    />
                                </div>

                                <div className="grid grid-cols-2 gap-4 border-0">
                                    <div>
                                        <DatePicker
                                            label="Start Date Time"
                                            selected={form.start_date_time}
                                            error={getFieldError('start_date_time')}
                                            onChange={date => handleInput('start_date_time', date)}
                                            showTimeSelect={true}
                                            timeIntervals={5}
                                        />
                                    </div>

                                    <div>
                                        <DatePicker
                                            label="End Date Time"
                                            selected={form.end_date_time}
                                            error={getFieldError('end_date_time')}
                                            onChange={date => handleInput('end_date_time', date)}
                                            showTimeSelect={true}
                                            timeIntervals={5}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <IsTranslatableWrapper
                                        label="Content"
                                        value={form.content}
                                        error={getFieldError('content')}
                                        onChange={value => handleInput('content', value)}
                                        supported_languages={form.supported_languages}
                                        childComponent="WYSIWYG"
                                        childProps={{}}
                                    />
                                </div>

                                <div>
                                    <IsTranslatableWrapper
                                        label="Presenters"
                                        value={form.presenters}
                                        error={getFieldError('presenters')}
                                        onChange={value => handleInput('presenters', value)}
                                        supported_languages={form.supported_languages}
                                        childComponent="WYSIWYG"
                                        childProps={{}}
                                    />
                                </div>

                                <div>
                                    <Select
                                        isMulti
                                        label="Speakers"
                                        options={this.state.speakers}
                                        value={form.speakers}
                                        onChange={(v) => handleInput('speakers', v)}
                                        isClearable={true}
                                    />
                                </div>

                                <div>
                                    <Select
                                        isMulti
                                        label="Group"
                                        options={this.timezones}
                                        value={form.user_type}
                                        onChange={(v) => handleInput('user_type', v)}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="bg-gray-300 p-4 rounded mb-8">
                            <h3 className="text-lg leading-6 font-medium py-4 font-bold">Add To Agenda Button</h3>

                            <div className="grid grid-cols-2 gap-4 py-8 border-0">
                                <div className="my-auto">
                                    <Toggle
                                        label="Show Add To Agenda Button"
                                        value={form.show_add_to_agenda_button}
                                        error={getFieldError('show_add_to_agenda_button')}
                                        onChange={v => handleInput('show_add_to_agenda_button', v)}
                                    />
                                </div>

                                {form.show_add_to_agenda_button &&
                                    <>
                                        <div className="mt-4">
                                            <Toggle
                                                label="Send Email When Added To Agenda"
                                                value={form.add_to_agenda_emails}
                                                error={getFieldError('add_to_agenda_emails')}
                                                onChange={v => handleInput('add_to_agenda_emails', v)}
                                            />
                                        </div>

                                        <div>
                                            <Input
                                                type="number"
                                                label="Spaces (Leave empty if unlimited)"
                                                value={form.spaces}
                                                id="title"
                                                error={getFieldError('spaces')}
                                                onChange={(v) => handleInput('spaces', v)}
                                            />
                                        </div>

                                        <div />

                                        {form.spaces &&
                                            <>
                                                <div className="mt-4">
                                                    <Toggle
                                                        label="Enable Waiting List"
                                                        value={form.waiting_list}
                                                        error={getFieldError('waiting_list')}
                                                        onChange={v => handleInput('waiting_list', v)}
                                                    />
                                                </div>

                                                <div className="mt-4">
                                                    <Toggle
                                                        label="Send Email When Moved Off Waiting List"
                                                        value={form.waiting_list_emails}
                                                        error={getFieldError('waiting_list_emails')}
                                                        onChange={v => handleInput('waiting_list_emails', v)}
                                                    />
                                                </div>
                                            </>
                                        }

                                        <div className="my-4"><p>Leave the below times empty to show by default.</p>
                                        </div>
                                        <div></div>

                                        <div>
                                            <DatePicker
                                                label="Show Add To Agenda Button Start Date Time"
                                                selected={form.show_add_to_agenda_button_start_date_time}
                                                error={getFieldError('show_add_to_agenda_button_start_date_time')}
                                                onChange={date => handleInput('show_add_to_agenda_button_start_date_time', date)}
                                                showTimeSelect={true}
                                                timeIntervals={5}
                                            />
                                        </div>

                                        <div>
                                            <DatePicker
                                                label="Show Add To Agenda Button End Date Time"
                                                selected={form.show_add_to_agenda_button_end_date_time}
                                                error={getFieldError('show_add_to_agenda_button_end_date_time')}
                                                onChange={date => handleInput('show_add_to_agenda_button_end_date_time', date)}
                                                showTimeSelect={true}
                                                timeIntervals={5}
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>

                        <div className="bg-gray-300 p-4 rounded mb-8">
                            <h3 className="text-lg leading-6 font-medium py-4 font-bold">Add To Calendar Button</h3>

                            <div className="grid grid-cols-2 gap-4 py-8 border-0">
                                <div className="my-auto">
                                    <Toggle
                                        label="Show Add To Calendar Button"
                                        value={form.show_add_to_calendar_button}
                                        error={getFieldError('show_add_to_calendar_button')}
                                        onChange={v => handleInput('show_add_to_calendar_button', v)}
                                    />
                                </div>

                                {form.show_add_to_calendar_button &&
                                    <div className="my-auto">
                                        <Toggle
                                            label="Show Add To Calendar Button Only If In Agenda"
                                            value={form.show_add_to_calendar_button_only_if_in_agenda}
                                            error={getFieldError('show_add_to_calendar_button_only_if_in_agenda')}
                                            onChange={v => handleInput('show_add_to_calendar_button_only_if_in_agenda', v)}
                                        />
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="bg-gray-300 p-4 rounded mb-8">
                            <h3 className="text-lg leading-6 font-medium py-4 font-bold">Join Link</h3>

                            <div className="grid grid-cols-2 gap-4 py-8 border-0">
                                <div>
                                    <Input
                                        label="Join Link (Include the http)"
                                        value={form.join_link}
                                        id="title"
                                        error={getFieldError('join_link')}
                                        onChange={(v) => handleInput('join_link', v)}
                                    />
                                </div>

                                {form.join_link &&
                                    <>
                                        <div className="my-auto">
                                            <Toggle
                                                label="Join Link Display Only If In Agenda"
                                                value={form.join_link_display_only_if_in_agenda}
                                                error={getFieldError('join_link_display_only_if_in_agenda')}
                                                onChange={v => handleInput('join_link_display_only_if_in_agenda', v)}
                                            />
                                        </div>

                                        <div className="my-4"><p>Leave the below times empty to show by default.</p>
                                        </div>
                                        <div></div>

                                        <div>
                                            <DatePicker
                                                label="Join Link Display Start Date Time"
                                                selected={form.join_link_display_start_date_time}
                                                error={getFieldError('join_link_display_start_date_time')}
                                                onChange={date => handleInput('join_link_display_start_date_time', date)}
                                                showTimeSelect={true}
                                                timeIntervals={5}
                                            />
                                        </div>

                                        <div>
                                            <DatePicker
                                                label="Join Link Display End Date Time"
                                                selected={form.join_link_display_end_date_time}
                                                error={getFieldError('join_link_display_end_date_time')}
                                                onChange={date => handleInput('join_link_display_end_date_time', date)}
                                                showTimeSelect={true}
                                                timeIntervals={5}
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="px-6 pt-6 flex justify-end gap-4">
                        <Link to="/admin/agenda">
                            <SecondaryButton type="button" text="Back" />
                        </Link>

                        <PrimaryButton
                            text="Save"
                            working={working}
                        />
                    </div>
                </form>
            </AdminLayout>
        )
    }
}

export default FormHandler(AgendaStore);
